// routes/PrivateRoute.js
import { Navigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const PrivateRoute = ({ children }) => {
  const user = localStorage.getItem("user");
  const loginTimestamp = localStorage.getItem("loginTimestamp");

  if (!user || !loginTimestamp) {
    return <Navigate to="/login" />;
  }

  const TWO_HOURS = 2 * 60 * 60 * 1000;
  const isExpired = Date.now() - parseInt(loginTimestamp) > TWO_HOURS;

  if (isExpired) {
    localStorage.clear();
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;